/**
 * File: italiansecret-customer-status.js
 * Purpose: Shared browser helper for Italian Secret returning-customer markers used by pre-checkout theme messaging.
 */

(function () {
  var MARKER_COOKIE_NAME = "is_returning_customer";
  var MARKER_STORAGE_NAME = "italiansecret_returning_customer";
  var LEGACY_MARKER_STORAGE_NAME = "is_returning_customer";
  var MARKER_DAYS = 365;

  function getCookieValue(name) {
    var escaped = name.replace(/([.*+?^${}()|[\]\\])/g, "\\$1");
    var match = document.cookie.match(new RegExp("(?:^|; )" + escaped + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : "";
  }

  function setCookieValue(name, value, days) {
    var maxAge = Math.max(0, Math.round((days || 0) * 24 * 60 * 60));
    var cookie = name + "=" + encodeURIComponent(value) + "; path=/; max-age=" + maxAge + "; SameSite=Lax";
    if (window.location.protocol === "https:") cookie += "; Secure";
    document.cookie = cookie;
  }

  function getStorageValue(name) {
    try {
      return window.localStorage.getItem(name) || "";
    } catch (e) {
      return "";
    }
  }

  function setStorageValue(name, value) {
    try {
      window.localStorage.setItem(name, value);
    } catch (e) {}
  }

  function isTruthyMarker(value) {
    return value === "true" || value === "1" || value === "yes";
  }

  function hasReturningMarker() {
    return (
      isTruthyMarker(getCookieValue(MARKER_COOKIE_NAME)) ||
      isTruthyMarker(getStorageValue(MARKER_STORAGE_NAME)) ||
      isTruthyMarker(getStorageValue(LEGACY_MARKER_STORAGE_NAME))
    );
  }

  function rememberReturningCustomer() {
    setCookieValue(MARKER_COOKIE_NAME, "1", MARKER_DAYS);
    setStorageValue(MARKER_STORAGE_NAME, "1");
    setStorageValue(LEGACY_MARKER_STORAGE_NAME, "1");
  }

  function resolveStatus(options) {
    var config = options || {};
    var serverStatus = config.serverStatus || "unknown";

    if (config.forceGuest) return "new";

    if (serverStatus === "returning") {
      rememberReturningCustomer();
      return "returning";
    }

    if (serverStatus === "new") return "new";

    return hasReturningMarker() ? "returning" : "unknown";
  }

  window.ItalianSecretCustomerStatus = {
    hasReturningMarker: hasReturningMarker,
    rememberReturningCustomer: rememberReturningCustomer,
    resolveStatus: resolveStatus,
  };
})();
